import { LoadingScreen } from '@/components';
import { useAuth } from '@/hooks';
import { Router } from '@/router';

function App() {
  const auth = useAuth();

  if (auth.isLoading) {
    return <LoadingScreen />;
  }

  if (!auth.isAuthenticated) {
    return (
      <button type="button" onClick={() => void auth.signinRedirect()}>
        Log in
      </button>
    );
  }

  return <Router />;
}

export default App;
